// LIST
export const FETCH_BUNDLES = "app/Bundles/FETCH_BUNDLES";
export const FETCH_BUNDLES_SUCCESS = "app/Bundles/FETCH_BUNDLES_SUCCESS";
export const FETCH_BUNDLES_FAILURE = "app/Bundles/FETCH_BUNDLES_FAILURE";

export const TOGGLE_CONFIRM = "app/Bundles/TOGGLE_CONFIRM";
export const TOGGLE_DELETE_PAYMENT = "app/Bundles/TOGGLE_DELETE_PAYMENT";
export const TOGGLE_CARD_MODAL = "app/Bundles/TOGGLE_CARD_MODAL";
export const SET_SUB_CART = "app/Bundles/SET_SUB_CART";
export const TOGGLE_SUB_MODAL = "app/Bundles/TOGGLE_SUB_MODAL";
export const TOGGLE_CARD_LIST = "app/Bundles/TOGGLE_CARD_LIST";
export const RESET_SUB_CART = "app/Bundles/RESET_SUB_CART";

export const SUBSCRIBE = "app/Bundles/SUBSCRIBE";
export const SUBSCRIBE_SUCCESS = "app/Bundles/SUBSCRIBE_SUCCESS";
export const SUBSCRIBE_FAILURE = "app/Bundles/SUBSCRIBE_FAILURE";

export const CANCEL_SUBSCRIPTION = "app/Bundles/CANCEL_SUBSCRIPTION";
export const CANCEL_SUBSCRIPTION_SUCCESS =
  "app/Bundles/CANCEL_SUBSCRIPTION_SUCCESS";
export const CANCEL_SUBSCRIPTION_FAILURE =
  "app/Bundles/CANCEL_SUBSCRIPTION_FAILURE";

export const UPDATE_SUBSCRIBE = "app/Bundles/UPDATE_SUBSCRIBE";
export const UPDATE_SUBSCRIBE_SUCCESS = "app/Bundles/UPDATE_SUBSCRIBE_SUCCESS";
export const UPDATE_SUBSCRIBE_FAILURE = "app/Bundles/SUBSCRIBE_FAILURE";

export const GET_PAYMENT_LIST = "app/Bundles/GET_PAYMENT_LIST";
export const GET_PAYMENT_LIST_SUCCESS = "app/Bundles/GET_PAYMENT_LIST_SUCCESS";
export const GET_PAYMENT_LIST_FAILURE = "app/Bundles/GET_PAYMENT_LIST_FAILURE";

export const GET_HISTORY = "app/Bundles/GET_HISTORY";
export const GET_HISTORY_SUCCESS = "app/Bundles/GET_HISTORY_SUCCESS";
export const GET_HISTORY_FAILURE = "app/Bundles/GET_HISTORY_FAILURE";

export const ADD_METHOD = "app/Bundles/ADD_METHOD";
export const ADD_METHOD_SUCCESS = "app/Bundles/ADD_METHOD_SUCCESS";
export const ADD_METHOD_FAILURE = "app/Bundles/ADD_METHOD_FAILURE";

export const EDIT_METHOD = "app/Bundles/EDIT_METHOD";
export const EDIT_METHOD_SUCCESS = "app/Bundles/EDIT_METHOD_SUCCESS";
export const EDIT_METHOD_FAILURE = "app/Bundles/EDIT_METHOD_FAILURE";

export const DELETE_METHOD = "app/Bundles/DELETE_METHOD";
export const DELETE_METHOD_SUCCESS = "app/Bundles/DELETE_METHOD_SUCCESS";
export const DELETE_METHOD_FAILURE = "app/Bundles/DELETE_METHOD_FAILURE";

export const GET_SUB_LIST = "app/Bundles/GET_SUB_LIST";
export const GET_SUB_LIST_SUCCESS = "app/Bundles/GET_SUB_LIST_SUCCESS";
export const GET_SUB_LIST_FAILURE = "app/Bundles/GET_SUB_LIST_FAILURE";

export const SET_DEFAULT = "app/Bundles/SET_DEFAULT";
export const SET_DEFAULT_SUCCESS = "app/Bundles/SET_DEFAULT_SUCCESS";
export const SET_DEFAULT_FAILURE = "app/Bundles/SET_DEFAULT_FAILURE";

export const REQ_DEMO = "app/Bundles/REQ_DEMO";
export const REQ_DEMO_SUCCESS = "app/Bundles/REQ_DEMO_SUCCESS";
export const REQ_DEMO_FAILURE = "app/Bundles/REQ_DEMO_FAILURE";
